import React, { ReactElement } from 'react'

// The conventional "AI feature" sparkles glyph. Inherits currentColor so it
// works on any button/text it sits inside.
export const AiSparkleIcon: React.FC<{ size?: string }> = ({
    size = '1em',
}): ReactElement => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        style={{ verticalAlign: '-0.125em' }}
    >
        <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6-5.6-1.9 5.6-1.9L12 2.5z" />
        <path d="M19 14l1 2.9 2.9 1-2.9 1L19 21.8l-1-2.9-2.9-1 2.9-1L19 14z" />
        <path d="M5.5 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2z" />
    </svg>
)
